import { useStore } from 'effector-react';
// @ts-ignore
import QRCode from 'pano-qrcode';
import { HOST, AVATAR_DOMAIN } from '@constants';
import { $member } from '@stores/memberStores';
import getTid from '@utils/getTid';

interface Props {
  className?: string;
  imageUrl?: string;
}

export default function TourQr({ className, imageUrl }: Props) {
  const member = useStore($member);
  const tourUrl = `${HOST}/vr/${getTid()}`;
  const avatarUrl = imageUrl || `${AVATAR_DOMAIN}${member.property?.avatar}`;

  return (
    <QRCode
      centreImg={avatarUrl}
      className={className}
      size={150}
      url={tourUrl}
    />
  );
}
